const ContactUsPage = () => {
  return (
    <div className="w-full min-h-screen bg-black-main-dark text-white">
      {/* HERO SECTION */}
      <section className="mt-32 pb-10 px-6 md:px-12 text-center">
        <h1 className="text-4xl md:text-5xl font-bold">
          Get in <span className="text-primary1">Touch</span>
        </h1>
        <p className="mt-4 text-lg text-gray-300 max-w-2xl mx-auto">
          We’re here to help with your investments, trading, or financial
          planning. Connect with us anytime and our experts will guide you.
        </p>
      </section>

      {/* CONTACT CARDS */}
      <section className="py-8 px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <div className="bg-gray-800 p-8 rounded-2xl shadow-lg text-center hover:bg-gray-700 transition">
          <h3 className="text-xl font-semibold mb-2">Phone</h3>
          <p className="text-gray-300">+91-9426228489</p>
          <p className="text-gray-300">+91-7862878915</p>
        </div>

        <div className="bg-gray-800 p-8 rounded-2xl shadow-lg text-center hover:bg-gray-700 transition">
          <h3 className="text-xl font-semibold mb-2">Email</h3>
          <p className="text-gray-300">contact@tradetact.in</p>
        </div>

        <div className="bg-gray-800 p-8 rounded-2xl shadow-lg text-center hover:bg-gray-700 transition">
          <h3 className="text-xl font-semibold mb-2">📍 Address</h3>
          <p className="text-gray-300">
            H-715 Swagat Twin City High Street, Sargasan, Gandhinagar
            <br />
            Gujarat, India - 382421
          </p>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="px-6 mt-10 md:px-12 pb-20 max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold mb-6 text-center">
          Our Location
        </h2>

        <div className="w-full h-[350px] rounded-2xl overflow-hidden shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.530561639741!2d72.61613197702111!3d23.187327510156642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2b0ca0daa217%3A0xf3ac8e6c276eaef!2sTradeTact%20Capital%20Solutions!5e0!3m2!1sen!2sin!4v1767348867256!5m2!1sen!2sin"
            width="100%"
            height="100%"
            title="location"
            style={{ border: 0 }}
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default ContactUsPage;
